// extracted by mini-css-extract-plugin
module.exports = {"container":"ThirdBlock-module--container--3acFB","heading":"ThirdBlock-module--heading--zX3JM","button":"ThirdBlock-module--button--1CurA"};